import { IAbsenceIn, IAbsenceUpdateIn } from '../../models/input/generalApi/IAbsenceIn'
import * as ApiWithToken from '../callApiWithToken'

const absenceService = {
  getAbsences: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API + `Absences/GetAbsencesWeb?idLanguage=${languageId}`,
    )
  },
  getAbsencesType: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API + `Absences/GetAbsencesType?languageID=${languageId}`,
    )
  },
  postAbsence: async function (absencesIn: IAbsenceIn[]) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_GENERAL_API + `Absences/InsertAbsences`,
      absencesIn,
    )
  },
  updateAbsence: async function (absencesUpdateIn: IAbsenceUpdateIn) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_GENERAL_API + `Absences/UpdateAbsenceNew`,
      absencesUpdateIn,
    )
  },
  deleteAbsence: async function (absenceId: number) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_GENERAL_API + `Absences/DeleteAbsence?deleteAbsenseIn=${absenceId}`,
      null,
    )
  },
  getAbsencesCategory: async function (languageId: number, typeId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API +
        `Absences/GetAbsencesCategory?languageID=${languageId}&typeID=${typeId}`,
    )
  },
}
export default absenceService
